import { handleActions } from 'redux-actions';

import { types } from '../constants';

import sites from '../constants/sites';

const INITIAL_STATE = {
  allPersonnels: {
    items: [],
    itemsCopy: [],
    isLoading: false,
    errorMessage: '',
    searchTerm: ''
  },
  sites: {
    items: sites()
  }
};

const changeSearchTermForAllPersonnels = (state, { searchTerm }) => {
  let personnels = state.allPersonnels.itemsCopy;

  let filteredCompanies = personnels.filter(
    (p) => p.firstName && p.firstName.toLowerCase().includes(searchTerm)
  );

  return {
    ...state,
    allPersonnels: {
      ...state.allPersonnels,
      searchTerm,
      items: filteredCompanies
    }
  };
};

const startFetchAllPersonnels = (state) => {
  return {
    ...state,
    allPersonnels: {
      ...state.allPersonnels,
      isLoading: true
    }
  };
};

const fetchAllPersonnelsSuccess = (state, { allPersonnels }) => {
  const activePersonnels = allPersonnels.filter((c) => c.statusId === 1);
  return {
    ...state,
    allPersonnels: {
      ...state.allPersonnels,
      items: activePersonnels,
      itemsCopy: activePersonnels
    }
  };
};

const fetchAllPersonnelsFailure = (state, { errorMessage }) => {
  return {
    ...state,
    allPersonnels: {
      ...state.allPersonnels,
      errorMessage
    }
  };
};

const fetchAllPersonnelsFinished = (state) => {
  return {
    ...state,
    allPersonnels: {
      ...state.allPersonnels,
      isLoading: false
    }
  };
};

const submitPersonnelSuccess = (state, { submittedPersonnel }) => {
  let personnels = [...state.allPersonnels.items];
  let updatedPersonnelIndex = personnels.findIndex(
    (c) => c.id === submittedPersonnel.id
  );

  //Means updated
  if (updatedPersonnelIndex !== -1) {
    personnels[updatedPersonnelIndex] = submittedPersonnel;
  }
  //Means newly created
  else {
    personnels = [...personnels, submittedPersonnel];
  }
  const activePersonnels = personnels.filter((c) => c.statusId === 1);
  return {
    ...state,
    allPersonnels: {
      ...state.allPersonnels,
      items: activePersonnels,
      itemsCopy: activePersonnels
    }
  };
};

//Handles the incoming actions.
export default handleActions(
  {
    [types.START_FETCH_ALL_PERSONNELS]: startFetchAllPersonnels,
    [types.FETCH_ALL_PERSONNELS_SUCCESS]: fetchAllPersonnelsSuccess,
    [types.FETCH_ALL_PERSONNELS_FAILURE]: fetchAllPersonnelsFailure,
    [types.FETCH_ALL_PERSONNELS_FINISHED]: fetchAllPersonnelsFinished,

    [types.SUBMIT_PERSONNEL_SUCCESS]: submitPersonnelSuccess,

    [types.CHANGE_SEARCH_TERM_ALL_PERSONNELS]: changeSearchTermForAllPersonnels
  },
  INITIAL_STATE
);
